<template>
  <div class="animation-dacia">
    <img
      :src="`${assetsUrl}assets/images/vue-bg-countdown-dacia.jpg`"
      alt="dacia background"
    >
    <div
      class="bg-scale js-element"
      data-animation="scale(100, 125)"
      data-from="top-bottom"
      data-to="bottom-top"
    >
      <img
        :src="`${assetsUrl}assets/images/vue-bg-montagne-scale.png`"
        alt="background montagne"
      >
    </div>
    <div class="clouds">
      <img
        :src="`${assetsUrl}assets/images/vue-clouds.png`"
        alt="clouds"
      >
    </div>
  </div>
</template>

<script>
export default {
  props: {
    assetsUrl: {
      type: String,
      required: true,
    },
  },
}
</script>
